import { apiRequest, login as authLogin } from '../utils/api';

// 登录
export const login = async (username, password) => {
  try {
    return await authLogin(username, password);
  } catch (error) {
    console.error('登录请求失败:', error);
    throw error;
  }
};

// 修改密码
export const changePassword = async (oldPassword, newPassword) => {
  try {
    const response = await apiRequest('/api/change-password', {
      method: 'POST',
      body: JSON.stringify({ old_password: oldPassword, new_password: newPassword })
    });
    return response;
  } catch (error) {
    console.error('修改密码失败:', error);
    throw error;
  }
};

// 获取可用时间
export const getAvailableTimes = async () => {
  try {
    const response = await apiRequest('/api/get_available_times');
    return response;
  } catch (error) {
    console.error('获取可用时间失败:', error);
    throw error;
  }
};


// 获取可预约列表
export const getAvailableList = async () => {
  try {
    const response = await apiRequest('/api/get_available_list');
    return response;
  } catch (error) {
    console.error('获取可预约列表失败:', error);
    throw error;
  }
};

export const refreshReservationData = async () => {
  try {
    const response = await apiRequest('/api/refresh_reservation_data', {
      method: 'POST',
    });
    return response;
  } catch (error) {
    console.error('强制刷新预约数据失败:', error);
    throw error;
  }
};

// 获取时间列表
export const getTimeList = async () => {
  try {
    const response = await apiRequest('/api/get_time_list');
    return response;
  } catch (error) {
    console.error('获取时间列表失败:', error);
    throw error;
  }
};






// 用户管理API
// 获取用户列表
export const getUsers = async () => {
  try {
    const response = await apiRequest('/api/get_users');
    return response;
  } catch (error) {
    console.error('获取用户列表失败:', error);
    throw error;
  }
};

// 保存用户
export const saveUser = async (name, phone, password) => {
  try {
    const response = await apiRequest('/api/save_user', {
      method: 'POST',
      body: JSON.stringify({ name, phone, password })
    });
    return response;
  } catch (error) {
    console.error('保存用户失败:', error);
    throw error;
  }
};

// 删除用户
export const deleteUser = async (uid) => {
  try {
    const response = await apiRequest('/api/delete_user', {
      method: 'POST',
      body: JSON.stringify({ uid })
    });
    return response;
  } catch (error) {
    console.error('删除用户失败:', error);
    throw error;
  }
};

// 验证所有用户账号状态（通过测试登录）
export const verifyAllUsers = async () => {
  try {
    const response = await apiRequest('/api/verify_all_users', {
      method: 'POST',
    });
    return response;
  } catch (error) {
    console.error('验证用户状态失败:', error);
    throw error;
  }
};

// 更新用户状态
export const updateUserStatus = async (uid, status) => {
  try {
    const response = await apiRequest('/api/update_user_status', {
      method: 'POST',
      body: JSON.stringify({ uid, status })
    });
    return response;
  } catch (error) {
    console.error('更新用户状态失败:', error);
    throw error;
  }
};

// 根据手机号获取用户信息的API已废弃，只使用uid

// 根据uid获取用户信息
export const getUserByUid = async (uid) => {
  try {
    const response = await apiRequest(`/api/get_user_by_uid/${uid}`);
    return response;
  } catch (error) {
    console.error('获取用户信息失败:', error);
    throw error;
  }
};

// 任务管理API
// 获取任务列表
export const getTasks = async () => {
  try {
    const response = await apiRequest('/api/get_tasks');
    return response;
  } catch (error) {
    console.error('获取任务列表失败:', error);
    throw error;
  }
};

export const getUserReservations = async (uid) => {
  try {
    const response = await apiRequest(`/api/get_user_reservations/${uid}`);
    return response;
  } catch (error) {
    console.error('获取用户已预约列表失败:', error);
    throw error;
  }
};

// 创建任务
export const createTask = async (taskData) => {
  try {
    const response = await apiRequest('/api/create_task', {
      method: 'POST',
      body: JSON.stringify(taskData)
    });
    return response;
  } catch (error) {
    console.error('创建任务失败:', error);
    throw error;
  }
};

// 立即预约
export const flashReserve = async (taskData) => {
  try {
    const response = await apiRequest('/api/flash_reserve', {
      method: 'POST',
      body: JSON.stringify(taskData)
    });
    return response;
  } catch (error) {
    console.error('立即预约失败:', error);
    throw error;
  }
};

export const submitBookingTask = async (taskData) => {
  if (taskData?.execution_mode === 'immediate') {
    return flashReserve(taskData);
  }
  return createTask(taskData);
};

// 删除任务
export const deleteTask = async (taskId, force = false) => {
  try {
    const response = await apiRequest('/api/delete_task', {
      method: 'POST',
      body: JSON.stringify({ task_id: taskId, force })
    });
    return response;
  } catch (error) {
    console.error('删除任务失败:', error);
    throw error;
  }
};

// 获取 API Key 信息
export const getApiKeyInfo = async () => {
  try {
    const response = await apiRequest('/api/api_key_info');
    return response;
  } catch (error) {
    console.error('获取 API Key 失败:', error);
    throw error;
  }
};

// 获取预约数据
export const getReservations = async () => {
  try {
    const response = await apiRequest('/api/get_reservations');
    return response;
  } catch (error) {
    console.error('获取预约数据失败:', error);
    throw error;
  }
};
